import './App.css';
import NavBar from './NavBar';
import CardTemplate from './CardTemplate';
import ContactForm from './ContactForm';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Row } from 'react-bootstrap';
import {Lightning, ListTask, Radioactive } from 'react-bootstrap-icons';
import Background from './images/background.png'
import React, { Component } from 'react';
import About from './About';
import WorksCarousel from './WorksCarousel';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardsArr: [],
      worksArr: []
    }
  }

  CardsArr = [
    {
      key: '1',
      title: "תכנון וייעוץ חשמל",
      text: 'הכנת תוכניות חשמל ועבודה צמודה עם הלקוחות עד לקבלת התוצאה הרצויה ע"י מומחים עם נסיון רב בתחום',
      icon: <Lightning size="70px"></Lightning>
    },
    {
      key: '2',
      title: "סקרי קרינה",
      text: "ביצוע בדיקות קרינה בעזרת מכשור מיוחד. הכנת סקרי קרינה לצורך קבלת היתרים.",
      icon: <Radioactive size="70px"></Radioactive>
    },
    {
      key: '3',
      title: "הובלת פרוייקטים ותיאום מול גורמי חוץ",
      text: "פיקוח וליווי ביצוע עבודות החשמל בפרויקטים קיימים וחדשים, תוך מתן הנחיות לביצוע, בהתאמה לדרישות חוק החשמל, התקנים הקיימים והנחיות חברת החשמל",
      icon: <ListTask size="70px"></ListTask>
    }
  ]

  Cards = this.CardsArr.map((item) => {
    return(
        <CardTemplate key={item.key} title={item.title} text={item.text} icon={item.icon}/>
    )
  })

  render() {
    return (
    <div className="App" dir='rtl' style={{backgroundImage: `url(${Background})`}}>
    <NavBar/>
    <About header={'קצת עלינו'} body={'חברת אליגמן פתרונות הנדסיים בע"מ נוסדה בשנת 2019. החברה נותנת פתרון תכנוני ויישומי למערכות החשמל, התקשורת והתאורה המשולבות בפרויקטים, במקצועיות, בעבודת צוות, תוך עמידה בלוחות זמנים ועם הכלים החדשים ביותר.                         בהתאמה לצרכי המזמין תמיד יימצא פתרון הנדסי מתאים לכל פרויקט, ייחודי ככל שיהיה, בשיתוף פעולה מלא, תוך התחשבות בתקציב ההקמה ובראיה עתידית של מכלול עלויות התפעול והתחזוקה של המתקן.'}/>
    <div id='services' className='container medium' style={{paddingTop: "70px"}}>
      <header>
        <h2>חברתנו מתמחה במגוון תחומים</h2>
        <h6>כאן ניתן לראות חלק מתחומי ההתמחות שלנו..</h6>
      </header>
      <div className='container'>
      <Row xs={1} md={4}>
        {
          this.Cards
        }
        </Row>
        </div>
      <footer>
        <h6 style={{margin: '2%'}}>נשמח לעמוד לרשותכם בכל אחד מהתחומים הללו ובתחומים נוספים.</h6>
      </footer>
    </div>
    <div id='works' className='container medium' style={{paddingTop: "70px"}}>
    <header>
        <h2>פרוייקטים שביצענו</h2>
        <h6>כאן ניתן לראות חלק מהפרוייקטים שביצענו...</h6>
      </header>
      <div className='container'>
          <WorksCarousel/>
      </div>
      <footer>
        <h6 style={{margin: '2%'}}>זוהי רק טעימה קטנה ממגוון הפרוייקטים שביצענו.</h6>
      </footer>
    </div>
    <div id='contact' className='container' >
      <ContactForm/>
      <footer>
      <p>
      כל הזכויות שמורות לאליגמן עיצוב: אלעד פלדמן &copy;
      </p>
    </footer>
    </div>
    </div>
  );
  }
}

export default App;
